module.exports = __webpack_public_path__ + "img/layout_time_arc.725f7f39.svg";